export { default } from './ReviewsSearchBox';
